/**
 * @file  core.js
 * @author  xiaohei
 * @date    2018/11/13
 * @description  core文件
 */

import axios from 'axios'
import config from '../../../config'
import BMF from 'browser-md5-file'
// 存储鉴权数据
let policyData = null

const bmf = new BMF()

/**
 * 取鉴权数据
 * */
function getPolicy(cb) {
  // 不重复取鉴权数据

  if (policyData && policyData.expire - Date.now() > 10000) {
    console.log(policyData.expire, Date.now())
    return cb(null, policyData)
  }
  axios
    .get(config.publicPath + '/api/oss/get_policy')
    .then(data => {
      console.log(data)
      if (data.status === 200) {
        policyData = data.data
        cb(null, data.data)
      } else {
        cb(new Error(data))
      }
    })
    .catch(e => {
      cb(e)
    })
}

// 只要引入文件就调用一次
getPolicy(() => {})

export default class UploadCore {
  constructor(getAttachmentIdFlag,md5flag = true) {
    this.name = 'UploadCore'
    this.getAttachmentIdFlag = getAttachmentIdFlag
    this.md5flag = md5flag
    this.fileList = []
  }

  /**
   * 多文件上传
   * @param fileList
   * @param endCb
   * @param progressCb
   * @param fileProgressCb
   */

  uploadFileList(fileList, endCb, progressCb, fileProgressCb) {
    let index = 0
    // 依次上传
    for (let i = 0; i < fileList.length; i++) {
      this.uploadFile(
        fileList[i],
        async (err, file) => {
          //console.log('单文件的上传回调', err, file);
          if (this.getAttachmentIdFlag) {
            file.suffix = UploadCore.getFileSuffix(file.name)
            UploadCore.setType(file)
            if (!err) await this.getAttachmentIdRequest(file)
          }
          progressCb && progressCb(err, file)
          index++
          if (index === fileList.length) {
            endCb(fileList)
          }
        },
        (e, file) => {
          fileProgressCb && fileProgressCb(e, file)
        }
      )
    }
  }

  /**
   * 上传单个文件
   * @param file
   * @param cb
   * @param fileProgressCb
   */
  uploadFile(file, cb, fileProgressCb) {
    getPolicy((err, data) => {
      if (err) {
        return cb(err, file)
      }
      let key = UploadCore.getUpFileKeyName(file.name, data.dir)
      // let actionUrl = 'http://' + data.data.domain;
      let actionUrl = data.host
      // 给file附加访问路径
      file.__remoteUrl = data.host + '/' + key
      //给file加上相对路径
      file.fileName = key
      // 上传地址
      const formData = new FormData()
      formData.append('success_action_status', 200)
      formData.append('policy', data['policy'])
      formData.append('OSSAccessKeyId', data['accessid'])
      formData.append('signature', data['signature'])
      formData.append('x-oss-security-token', data['sts_token'])
      formData.append('key', key)
      formData.append('file', file)

      //异步上传解析MD5码
      Promise.all([
        axios.post(actionUrl, formData, {
          onUploadProgress: (file => {
            return e => {
              fileProgressCb && fileProgressCb(e, file)
            }
          })(file)
        }),
        this.md5flag && this.calculateMd5(file)
      ])
        .then(([data, md5]) => {
          // 给file附加MD5
          file.__md5 = md5
          if (data.status === 200) cb(null, file)
          else cb(data, file)
        })
        .catch(err => {
          cb(err, file)
        })
    })
  }

  /**
   * 获取文件后缀
   * @param filename
   * @return {string}
   */
  static getFileSuffix(filename) {
    let pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos !== -1) {
      suffix = filename.substring(pos)
      suffix = suffix.toLowerCase()
    }
    return suffix
  }

  /**
   * 获取文件的随机路径
   * @param filename
   * @param aliyunPath
   * @return {*}
   */
  static getUpFileKeyName(filename, aliyunPath) {
    let suffix = UploadCore.getFileSuffix(filename)
    return aliyunPath + parseInt(Math.random() * 1e12) + Date.now() + suffix
  }

  /**
   * 返回生成MD5码的promise
   * @param file
   * @returns {Promise<any>}
   */
  calculateMd5(file) {
    return new Promise(function(resolve, reject) {
      bmf.md5(
        file,
        (err, md5) => {
          // console.log('err:', err);
          // console.log('md5 string:', md5); // 97027eb624f85892c69c4bcec8ab0f11
          if (err) reject(err)
          else resolve(md5)
        },
        progress => {
          console.log('md5 progress number:', progress)
        }
      )
    })
  }

  /**
   * 设置资源、附件类型
   * @param file
   * type: "integer 资源类型:1-图片;2-音频;3-视频;4-文字;5-文档;",
   * 附件类型 1.PPT 2.PDF 3.Excel 4.Word 5.图片 6、txt 7.音频 8.视频 ,
   * @returns {*}
   */
  static setType(file) {
    if ('.jpg,.jpeg,.tiff,.gif,.png,.bmp,.raw'.indexOf(file.suffix) > -1) {
      file.__type = 1
      file.__docType = 5
    } else if ('.mp3'.indexOf(file.suffix) > -1) {
      file.__type = 2
      file.__docType = 7
    } else if (
      '.mp4,.flv,.3gp,.rm,.avi,.mkv,.wmv,.mov,.rmvb,.mid,.mp2,.mpa,.ra,.asf,.mpg,.mpeg,.avs,.dat,.ogm,.vob,.ts,.tp,.ifo,.nsv'.indexOf(
        file.suffix
      ) > -1
    ) {
      file.__type = 3
      file.__docType = 8
    } else if ('.ppt,.pptx'.indexOf(file.suffix) > -1) {
      file.__type = 4
      file.__docType = 1
    } else if ('.pdf'.indexOf(file.suffix) > -1) {
      file.__type = 4
      file.__docType = 2
    } else if ('.xls,.xlsx'.indexOf(file.suffix) > -1) {
      file.__type = 4
      file.__docType = 3
    } else if ('.doc,.docx,.wps'.indexOf(file.suffix) > -1) {
      file.__type = 4
      file.__docType = 4
    } else if ('.txt'.indexOf(file.suffix) > -1) {
      file.__type = 4
      file.__docType = 6
    }
    return file
  }

  /**
   * 获取上传文件或图片的附件Id
   * @param file
   * @param callback
   */
  getAttachmentIdRequest(file, callback) {
    return axios
      .post(config.publicPath + '/api/gateway/cms/attachementApi_create', {
        //cover: "string 多媒体首帧图",
        fileSize: file.size,
        md5: file.__md5,
        mediaUrl: file.__remoteUrl, //转码后地址，先取原始地址，后台自己update
        originalUrl: file.__remoteUrl,
        //playTime: "integer 播放时长（单位毫秒）",
        suffix: file.suffix,
        type: file.__type
        //zipUrl: "string 压缩包地址"
      })
      .then(data => {
        data = data.data
        file.attachmentId = data.data.contentId
      })
  }
}
